<template>
  <div class="columns">
    <div v-if="modalState">
      <ModalCreateOfYourSite />
    </div>
    <div ref="canvasContainer" class="column is-two-thirds">
      <canvas ref="canvas"></canvas>
    </div>
    <div class="steps-descriptions column is-one-thirds">
      <a ref="btnDownload"
        ><button class="button margin-bottom is-primary">
          <base-icon
            class="has-text-white"
            style="margin-right: 0.5em"
            width="24px"
            height="24px"
            name="painel/download"
          />
          Download
        </button>
      </a>
      <stepsOfEditionCanvas />
    </div>
  </div>
</template>

<script>
import { fabric } from 'fabric'
import stepsOfEditionCanvas from '@/components/Invites/StepsOfEditionCanvas'
import ModalCreateOfYourSite from '@/components/Invites/modalCreateSite'

import dataCanvas from '@/lib/invites/layoutsData'

import Invites from '@/lib/api/Invites'

export default {
  components: {
    stepsOfEditionCanvas,
    ModalCreateOfYourSite,
  },

  computed: {
    logonToken() {
      return this.$store.state.app.logonToken
    },

    infosWedding: {
      get() {
        return this.$store.state.invites.weddingInfos
      },
      set(payload) {
        this.$store.dispatch('setWeddingInfo', payload)
      },
    },

    modalState: {
      get() {
        return this.$store.state.invites.modalState
      },
      set(payload) {
        this.$store.dispatch('setOpenModal', payload)
      },
    },
  },

  data() {
    return {
      started: false,
      months: [
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro',
      ],
    }
  },

  watch: {
    logonToken(payload) {
      if (payload && payload.token && !this.started) {
        !this.infosWedding.casamento_data
          ? this.getData(payload)
          : this.createCanvas()
      } else {
        this.createCanvas()
      }
    },
  },

  mounted() {
    if (this.logonToken && this.logonToken.token && !this.started) {
      !this.infosWedding.casamento_data
        ? this.getData(this.logonToken)
        : this.createCanvas()
    } else {
      this.createCanvas()
    }
  },

  methods: {
    async getData(token) {
      this.started = true
      const savetheDateData = new Invites(token)
      const response = await savetheDateData.getSaveTheDateInfo(
        token.token_payload.wed_id
      )
      const mySiteInfo = response.data
      if (mySiteInfo) this.infosWedding = mySiteInfo

      this.createCanvas()
    },

    getWeddingInfos() {
      return this.infoWedding
    },

    formatedDate(date) {
      const result = date.split('-')

      if (
        this.getModelLayout() === 'floral-clean' ||
        this.getModelLayout() === 'floral-ellegance' ||
        this.getModelLayout() === 'floral-maritimo' ||
        this.getModelLayout() === 'floral-rustico' ||
        this.getModelLayout() === 'floral-night'
      ) {
        return `${result[2]}/${result[1]}/${result[0]}`
      } else if (
        this.getModelLayout() === 'conchas-oceano' ||
        this.getModelLayout() === 'algas-marinhas' ||
        this.getModelLayout() === 'por-sol'
      ) {
        return this.uppercaseText(
          `${result[2]} de ${this.months[parseInt(result[1]) - 1]} de ${
            result[0]
          }`
        )
      } else {
        return `${result[2]} - ${result[1]} - ${result[0]}`
      }
    },

    getModelLayout() {
      return this.$router.currentRoute.params.modelo
    },

    uppercaseText(text) {
      if (
        this.getModelLayout() === 'conchas-oceano' ||
        this.getModelLayout() === 'algas-marinhas' ||
        this.getModelLayout() === 'por-sol'
      ) {
        return text.toUpperCase()
      } else return text
    },

    createCanvas() {
      this.started = true
      var FontFaceObserver = require('fontfaceobserver')

      // GET DATA OBJ TEXT OF CANVAS
      let infoOfLayout = {}
      infoOfLayout.title = this.uppercaseText('Save The Date')

      infoOfLayout.date = !this.infosWedding.casamento_data
        ? this.formatedDate('2020-08-31')
        : this.formatedDate(this.infosWedding.casamento_data)

      infoOfLayout.names =
        !this.infosWedding.noivo1_nome || !this.infosWedding.noivo2_nome
          ? this.uppercaseText('Romeo & Julieta')
          : this.uppercaseText(
              `${this.infosWedding.noivo1_nome} & ${this.infosWedding.noivo2_nome}`
            )

      infoOfLayout.urlSite = !this.infosWedding.site_url
        ? 'www.romeoejulieta.com'
        : this.infosWedding.site_url

      infoOfLayout.password = !this.infosWedding.site_senha
        ? ' '
        : `Senha: ${this.infosWedding.site_senha}`

      const model = dataCanvas.simples[this.getModelLayout()]

      const imageBackgroudLayout = require(`@/assets/img/invites/simple/${model.pathImage}`)

      var fonts = [
        'Sacramento',
        'Dosis',
        'Dancing Script',
        'Euphoria Script',
        'Playfair Display SC',
        'Great Vibes',
        'Nunito',
        'Asap',
        'Baloo 2',
        'Oswald',
      ]

      var fontInstancia = []

      fonts.forEach((font) => {
        fontInstancia.push(new FontFaceObserver(font).load())
      })

      const widthCanvas = this.$refs.canvasContainer.clientWidth - 24
      const widthObjs = 420

      const ref = this.$refs.canvas

      const canvas = new fabric.Canvas(ref)
      canvas.setWidth(widthCanvas)
      canvas.setHeight(widthCanvas)
      ref.classList.add('canvas-border')

      var scaleWidth = canvas.width / 1500
      var scaleHeight = canvas.height / 1500

      var scale = Math.min(scaleWidth, scaleHeight)

      fabric.Image.fromURL(imageBackgroudLayout, function (image) {
        image.set({
          selectable: false,
          scaleX: scale,
          scaleY: scale,
        })
        canvas.setBackgroundImage(image)
        canvas.renderAll()
      })

      const width50Canvas = canvas.width / 2
      var scaleWidthObj = canvas.width / canvas.width
      var scaleObj = Math.min(scaleWidthObj, scaleWidthObj)
      const marginTopCanvas = (canvas.height * 25) / 100
      Promise.all(fontInstancia)
        .then(function () {
          const textTitle = new fabric.Textbox(`${infoOfLayout.title}`, {
            fontFamily: model.textTitle.font,
            fontSize: model.textTitle.size,
            fill: model.textTitle.color,
            fontWeight: model.textTitle.weight,
            textAlign: model.textTitle.align,
            left: width50Canvas - widthObjs / 2,
            top: marginTopCanvas + model.textTitle.top,
            width: widthObjs,
            scaleX: scaleObj,
            scaleY: scaleObj,
          })
          textTitle.objectCaching = false
          textTitle.caching = false
          textTitle.lockRotation = true
          textTitle.hasRotatingPoint = false
          textTitle.lockUniScaling = true

          const textDate = new fabric.Textbox(`${infoOfLayout.date}`, {
            fontFamily: model.textDate.font,
            fontSize: model.textDate.size,
            fill: model.textDate.color,
            fontWeight: model.textDate.weight,
            textAlign: model.textDate.align,
            left: width50Canvas - widthObjs / 2,
            top: marginTopCanvas + model.textDate.top,
            width: widthObjs,
            scaleX: scaleObj,
            scaleY: scaleObj,
          })
          textDate.objectCaching = false
          textDate.caching = false
          textDate.lockRotation = true
          textDate.hasRotatingPoint = false
          textDate.lockUniScaling = true

          const textName = new fabric.Textbox(`${infoOfLayout.names}`, {
            fontFamily: model.textName.font,
            fontSize: model.textName.size,
            fill: model.textName.color,
            fontWeight: model.textName.weight,
            textAlign: model.textName.align,
            lineHeight: 0.9,
            left: width50Canvas - widthObjs / 2,
            top: marginTopCanvas + model.textName.top,
            width: 420,
            fixedWidth: widthObjs,
            scaleX: scaleObj,
            scaleY: scaleObj,
          })
          textName.objectCaching = false
          textName.caching = false
          textName.lockRotation = true
          textName.hasRotatingPoint = false
          textName.lockUniScaling = true

          canvas.on('text:changed', function (opt) {
            var t1 = opt.target
            if (t1.width > t1.fixedWidth) {
              t1.fontSize *= t1.fixedWidth / (t1.width + 1)
              t1.width = t1.fixedWidth
            }
          })

          const textSite = new fabric.Textbox(`${infoOfLayout.urlSite}`, {
            fontFamily: model.textSite.font,
            fontSize: model.textSite.size,
            fill: model.textSite.color,
            fontWeight: model.textSite.weight,
            textAlign: model.textSite.align,
            left: width50Canvas - widthObjs / 2,
            top: marginTopCanvas + model.textSite.top,
            width: widthObjs,
            scaleX: scaleObj,
            scaleY: scaleObj,
          })

          textSite.caching = false
          textSite.lockRotation = true
          textSite.hasRotatingPoint = false
          textSite.lockUniScaling = true
          textSite.objectCaching = false

          const textPassword = new fabric.Textbox(`${infoOfLayout.password}`, {
            fontFamily: model.textPassword.font,
            fontSize: model.textPassword.size,
            fill: model.textPassword.color,
            fontWeight: model.textPassword.weight,
            textAlign: model.textPassword.align,
            left: width50Canvas - widthObjs / 2,
            top: marginTopCanvas + model.textPassword.top,
            width: widthObjs,
            scaleX: scaleObj,
            scaleY: scaleObj,
          })

          textPassword.caching = false
          textPassword.lockRotation = true
          textPassword.hasRotatingPoint = false
          textPassword.lockUniScaling = true
          textPassword.objectCaching = false

          canvas.add(textTitle)
          canvas.add(textDate)
          canvas.add(textName)
          canvas.add(textSite)
          canvas.add(textPassword)

          if (widthCanvas <= 500) {
            var SCALE_FACTOR = 1
            var TOP_ELEMENT = 0
            widthCanvas > 400 ? (SCALE_FACTOR = 0.67) : (SCALE_FACTOR = 0.57)
            widthCanvas <= 300 ? (TOP_ELEMENT = 0) : (TOP_ELEMENT = 40)

            var objects = canvas.getObjects()
            for (var i in objects) {
              var scaleX = objects[i].scaleX
              var scaleY = objects[i].scaleY
              var top = objects[i].top

              var tempScaleX = scaleX * SCALE_FACTOR
              var tempScaleY = scaleY * SCALE_FACTOR
              var tempLeft = widthCanvas / 2 - (widthObjs * SCALE_FACTOR) / 2
              var tempTop = top * SCALE_FACTOR + TOP_ELEMENT

              objects[i].scaleX = tempScaleX
              objects[i].scaleY = tempScaleY
              objects[i].left = tempLeft
              objects[i].top = tempTop

              objects[i].setCoords()
            }
          }

          canvas.renderAll()
        })
        .catch(function (err) {
          console.warn('Some critical font are not available:', err)
        })

      let multiplierSizeImage = 2.8

      if (widthCanvas >= 451 && widthCanvas <= 600) {
        multiplierSizeImage = 2
      } else if (widthCanvas >= 601) {
        multiplierSizeImage = 1.4
      }
      const button = this.$refs.btnDownload

      button.addEventListener('click', () => {
        canvas.discardActiveObject().renderAll()
        if (!this.logonToken._result) {
          setTimeout(() => {
            this.modalState = true
          }, 800)
        }
        const hrefImage = canvas.toDataURL({
          format: 'png',
          quality: 1,
          multiplier: multiplierSizeImage,
        })

        this.$ga.event('Button', 'click', 'DownloadSaveTtheDate')

        const link = this.$refs.btnDownload

        if (navigator.userAgent.match(/iPhone/i)) {
          var image = new Image()
          image.src = hrefImage
          var w = window.open('')
          w.document.write(image.outerHTML)
        } else {
          link.href = hrefImage
          link.setAttribute('download', 'SaveTheDate-casarpontocom')
        }
      })
    },
  },
}
</script>

<style lang="scss">
.save-the-date-layout {
  &--button-download {
    margin-top: 64px;
  }

  &__description {
    margin-bottom: 32px;
  }
}
</style>
